module.exports = __webpack_public_path__ + "img/ergediandian.9efb1fc6.webp";